import { BadgeCheck, Quote } from "lucide-react";
import { Reveal } from "../landing/Reveal";

const TESTIMONIALS = [
  {
    name: "Ishita Rao",
    role: "Student",
    grad: "from-[#635BFF] to-[#8B85FF]",
    quote: "LearnNova quests paid for my entire semester of textbooks. My grades went up because studying finally felt like a game I was winning.",
  },
  {
    name: "Kabir Singh",
    role: "Chef",
    grad: "from-[#FF7A00] to-[#FFB25E]",
    quote: "I run a Friday-night biryani kitchen from my hostel. FoodNova handles orders, payments and my ingredient runs from local farms.",
  },
  {
    name: "Meera Krishnan",
    role: "Recruiter",
    grad: "from-[#00D26A] to-[#4ADE80]",
    quote: "We hired 14 interns through CareerNova last quarter. The skill graphs beat any resume pile I've ever screened.",
  },
  {
    name: "Ramesh Patel",
    role: "Farmer",
    grad: "from-[#06B6D4] to-[#67E8F9]",
    quote: "My tomatoes reach campus kitchens in hours, not days. I see the demand forecast before I even harvest.",
  },
  {
    name: "Zoya Sheikh",
    role: "Creator",
    grad: "from-[#EC4899] to-[#F472B6]",
    quote: "My fashion reels on FUNZ turned into actual ShopNova sales. First platform where views and revenue are the same dashboard.",
  },
];

export const SiteTestimonials = () => (
  <section id="testimonials" data-testid="site-testimonials" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#00D26A]">
          Testimonials
        </p>
        <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Loved across every corner of campus.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={0.06 * i} className="h-full">
            <figure
              data-testid={`testimonial-${t.role.toLowerCase()}`}
              className="flex h-full flex-col rounded-3xl border border-white/10 bg-[#111827]/80 p-6 backdrop-blur-xl transition-all duration-300 hover:-translate-y-1.5 hover:border-[#635BFF]/50"
            >
              <Quote className="h-5 w-5 text-[#635BFF]" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-300">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br ${t.grad} font-display text-xs font-black text-white`}>
                  {t.name.split(" ").map((w) => w[0]).join("")}
                </span>
                <div>
                  <p className="flex items-center gap-1 text-sm font-bold text-white">
                    {t.name}
                    <BadgeCheck className="h-3.5 w-3.5 text-[#00D26A]" />
                  </p>
                  <p className="font-jbmono text-[10px] uppercase tracking-widest text-slate-500">
                    {t.role}
                  </p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
